(function($){
    window.Application = {
        ready: function () {

            /* Menu hamburger */
            $('.main-menu__hamburger').click(function(){
                $('.main-menu__hamburger-icon').toggleClass('active');
                $('.main-menu__submenu').toggleClass('active');
                $('html').toggleClass('menu-active');
            });

        }
    };
})(jQuery);

// Initiate the application
jQuery(function () {
    Application.ready();
});